import db from "@/firebase/init";
import emptyStandardExerciseScores from '../assets/data/emptyStandardExerciseScores.js';

export default {
  data() {
    return {
      objectToStore: {
        userLevelsCompareIntervalSizes: [],
        userLevelsIdentifyIntervals: [],
        userLevelsIdentifyChords: [],
        userLevelsIdentifyChordInversions: [],
        userLevelsIdentifyScales: [],
        standardExerciseScores: emptyStandardExerciseScores
      }
    }
  },
  methods: {
    storeInDatabase(uid) {
      return db.collection('users').doc(uid).set(this.objectToStore).then(() => {
        //this.$router.push("/").catch(() => {});
      }).catch((err) => {
        console.log(err.message);
      })
    }, 
    setupNewUserInDatabase(user) {
      // let objectToStore = null;
      const uid = user.uid;
      // Check if there is old eb-game data stored in localstorage
      const ebGameLocalStorage = window.localStorage.getItem('eb-game');
      // Check if there is old eb-game data stored in localstorage
      if (ebGameLocalStorage === null) {
        // Does not exist.. Go ahead and set up empty user in firestore.
       
        this.storeInDatabase(uid);

      } else {
        const gameStorageObject = JSON.parse(ebGameLocalStorage);
        // delete game settings property
        delete gameStorageObject.gameSettings;

        // Check if has standard exercise scores
        let stdExerciseScores = gameStorageObject.standardExerciseScores;
        let totalScores = 0;

        for (let prop in stdExerciseScores) {
          let scoreArray = stdExerciseScores[prop];
          totalScores += scoreArray.reduce((a, b) => a + b, 0)
        }
       
        // Check if user Exercise Arrays are empty
        let numberOfUserStoredExercises = 0;
        // Add all user exercises from all disciplines
        numberOfUserStoredExercises += gameStorageObject.userLevelsCompareIntervalSizes.length;
        numberOfUserStoredExercises += gameStorageObject.userLevelsIdentifyChordInversions.length;
        numberOfUserStoredExercises += gameStorageObject.userLevelsIdentifyChords.length;
        numberOfUserStoredExercises += gameStorageObject.userLevelsIdentifyIntervals.length;
        numberOfUserStoredExercises += gameStorageObject.userLevelsIdentifyScales.length;

         // If totalScores greater than 0, then no scores have been added
        if (totalScores > 0 || numberOfUserStoredExercises > 0) {
          // User already has data stored locally. Ask if user wants to save those in database
          this.objectToStore = gameStorageObject;
          this.storeInDatabase(uid);
          this.$store.dispatch('setShowDataCopiedToDatabaseDialog', true);

          // console.log('User has data stored locally. Ask if user wants to save those in database');
        } else {
          // No scores or exercises stored on users computer
          // Setup empty database in Firestore
          this.storeInDatabase(uid);
        }
      }

    }
  }
}